import { createAction } from '@reduxjs/toolkit'

export const AUTH_CHECK = 'AUTH_CHECK'

export const authCheck = createAction(AUTH_CHECK)
